import './SessionModal.scss';

import cn from 'classnames';
import React from 'react';
import { Modal } from 'rsuite';

import Button from '@/common/components/atoms/Button/Button';
import {
  SessionModalDefaultProps,
  SessionModalPropTypes,
} from '@/ebat/components/blocks/Scanbat/SessionModals/SessionModal.proptypes';

export const BASE_CLASSNAME = 'scanbat-session-modal';

const SessionModal = ({ className, content, isOpen, onActionClick }) => (
  <Modal
    className={cn(BASE_CLASSNAME, className)}
    open={isOpen}
    overflow={false}
    size="sm"
  >
    <Modal.Body>
      <h6 className={`${BASE_CLASSNAME}__title`}>{content.title}</h6>
      <p className={`${BASE_CLASSNAME}__body`}>{content.body}</p>
      <Button
        className={`${BASE_CLASSNAME}__action`}
        onClick={onActionClick}
        variant="simple"
      >
        {content.action}
      </Button>
    </Modal.Body>
  </Modal>
);

SessionModal.defaultProps = {
  ...SessionModalDefaultProps,
};

SessionModal.propTypes = {
  ...SessionModalPropTypes,
};

export default SessionModal;
